import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AccentProvider"] */ "/vercel/path0/frontend/src/components/AccentProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/PersistentBackdropMount.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/SplashScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WalletProviderClient"] */ "/vercel/path0/frontend/src/components/WalletProviderClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfileProvider"] */ "/vercel/path0/frontend/src/lib/profile-store.tsx");
